<template>
  <div>
      <v-flex xs12 v-if="userId">
        <add-user-favorite
          type="favorite_search"
          :favorite="selectedFavorite"
          :userId="userId"
          @AssetSelected="selected"
        >
        </add-user-favorite>    
      </v-flex>
  </div>
</template>

<script>
  import Vue from 'vue'
  import { mapGetters } from 'vuex'
  import * as types from "../store/types"  
  import AddUserFavorite from "../components/asset/AddUserFavorite.vue"

  export default {
    components:{
      AddUserFavorite
    },
    data() {
      return {
        showWizard:true,
        selectedGeoZone:null,
        selectedAsset:null,
        selectedFavorite:null,
      }
    },
    computed: {
        ...mapGetters({
            currentUser: types.CURRENT_USER,
        }),
        userId(){
          return this.currentUser ? this.currentUser.id : null
        }
    },
    methods: {
      selected(asset){
        console.log("deze asset is geselecteerd:", asset)
      }
    },
    mounted(){

    }
  } 
</script>

<style scoped>

</style>
